export enum InviteReviewedStatusStateWhoToMail {
  patient = 1,
  staff = 2,
  both = 3,
}